export default function appendToMapArray<T, V>(
  map: Map<T, Array<V>>,
  key: T,
  value: V
): void {
  const list = map.get(key)
  if (!list) {
    map.set(key, [value])
  } else {
    list.push(value)
  }
}